import {
  DIMENSION_ADMIN_GET_LIST_INIT,
  DIMENSION_ADMIN_GET_LIST_SUCCESS,
  DIMENSION_ADMIN_GET_LIST_FAILURE,
  DIMENSION_ADMIN_SAVE_INIT,
  DIMENSION_ADMIN_SAVE_SUCCESS,
  DIMENSION_ADMIN_SAVE_FAILURE,
  DIMENSION_ADMIN_DELETE_INIT,
  DIMENSION_ADMIN_DELETE_PREPARE_INIT,
  DIMENSION_ADMIN_DELETE_SUCCESS,
  DIMENSION_ADMIN_DELETE_FAILURE,
  DIMENSION_ADMIN_SET_SAVE_DATA_BY_KEY,
  DIMENSION_ADMIN_SAVE_RESET,
  DIMENSION_GET_DIMENSION_INSTANCES_INIT,
  DIMENSION_GET_DIMENSION_INSTANCES_SUCCESS,
  DIMENSION_GET_DIMENSION_INSTANCES_FAILURE,
  DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_INIT,
  DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_SUCCESS,
  DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_FAILURE,
  DIMENSION_IMPORT_DIMENSION_INSTANCES_INIT,
  DIMENSION_IMPORT_DIMENSION_INSTANCES_SUCCESS,
  DIMENSION_IMPORT_DIMENSION_INSTANCES_FAILURE,
  DIMENSION_IMPORT_DIMENSION_INSTANCES_RESET,
  DIMENSION_ADMIN_GET_TAGS_LIST_INIT,
  DIMENSION_ADMIN_GET_TAGS_LIST_SUCCESS,
  DIMENSION_ADMIN_GET_TAGS_LIST_FAILURE,
  DIMENSION_ADMIN_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: DIMENSION_ADMIN_RESET
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: DIMENSION_ADMIN_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_ADMIN_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_ADMIN_GET_LIST_FAILURE, error));
    }  
  };
}

export function saveEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DIMENSION_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/save",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveEntityDataByKey(key, value) {
  return {
    type: DIMENSION_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveEntity(data) {
  return {
    type: DIMENSION_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function prepareDeleteEntity(id) {
  return {
    type: DIMENSION_ADMIN_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DIMENSION_ADMIN_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_ADMIN_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_ADMIN_DELETE_FAILURE, error));
    }  
  };
}

export function getDimensionInstances(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: DIMENSION_GET_DIMENSION_INSTANCES_INIT,
      params: params
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/getdimensioninstances",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_GET_DIMENSION_INSTANCES_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_GET_DIMENSION_INSTANCES_FAILURE, error));
    }  
  };
}

export function downloadImportFileDimensionInstances(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/dimension/downloaddimenesioninstancesimportfile",
        intl.formatMessage(
          { id: "common.entity.importFileName"}, 
          { entityNamePlural: intl.formatMessage({ id: "dimensionAdmin.dimensionInstancesNamePlural" } ) } 
        ),
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_DOWNLOAD_IMPORT_DIMENSION_INSTANCES_FILE_FAILURE, error));
    }  
  };
}

export function importDimensionInstances(files, params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DIMENSION_IMPORT_DIMENSION_INSTANCES_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/dimension/importdimenesioninstances",
        files,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_IMPORT_DIMENSION_INSTANCES_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_IMPORT_DIMENSION_INSTANCES_FAILURE, error));
    }  
  };
}

export function resetImportDimensionInstances() {
  return {
    type: DIMENSION_IMPORT_DIMENSION_INSTANCES_RESET
  };
}

export function getTagsList() {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: DIMENSION_ADMIN_GET_TAGS_LIST_INIT
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/tags/getlist",
        "POST",
        null,
        null,
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DIMENSION_ADMIN_GET_TAGS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DIMENSION_ADMIN_GET_TAGS_LIST_FAILURE, error));
    }  
  };
}

export function resetImport() {
  return {
    type: DIMENSION_IMPORT_RESET
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/dimensionAdmin/index.js